import { EFeatureFlag } from '@/beta-flag/enums/feature-flag';
import { FeatureFlagQueries } from '@/beta-flag/graphql/feature-flag.queries';
import { FeatureFlagMutations } from '@/beta-flag/graphql/feature-flag.mutations';
import { apolloClient } from '@/apollo';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class FeatureFlagService {
  static async evaluateFlag(feature: EFeatureFlag): Promise<number> {
    try {
      const {
        data: { evaluateFeatureFlag },
      } = await apolloClient.query({
        query: FeatureFlagQueries.evaluateFeatureFlag,
        variables: {
          feature,
        },
        fetchPolicy: EFetchPolicy.NetworkOnly,
      });
      return +evaluateFeatureFlag;
    } catch {
      return 0;
    }
  }

  static async allowFeature(feature: EFeatureFlag): Promise<number> {
    const {
      data: { allowEntityFeature },
    } = await apolloClient.mutate({
      mutation: FeatureFlagMutations.allowFeature,
      variables: {
        feature,
      },
      fetchPolicy: EFetchPolicy.NoCache,
    });
    return +allowEntityFeature;
  }

  static async isBlacklisted(feature: EFeatureFlag): Promise<boolean> {
    const {
      data: { isBlacklisted },
    } = await apolloClient.query({
      query: FeatureFlagQueries.isBlacklisted,
      variables: { feature },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return isBlacklisted;
  }
}
